const bitToKbps = (bit, roundResult = false) => {
  const result = bit / 1000;
  if (roundResult) {
    return Math.round(result);
  }
  return result;
};

export default bitToKbps;
